import { useStyletron } from 'baseui'
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import { KIND, SIZE } from 'baseui/button'
import { TYPE } from 'baseui/select'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useNavigate } from 'react-router'
import SDSelect from '@/shared/components/SDComponents/SDSelect/SDSelect'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useBusinessType from '@/shared/hooks/useBusinessType'
import {
  selectOrganizationsGeneral,
  selectOrganizationsSelectedProvider,
} from '../organizationsManagementSelectors'
import { organizationsManagementActions } from '../organizationsManagementSagas'

const Heading = () => {
  const dispatch = useDispatch()
  const providerGeneral = useSelector(selectOrganizationsGeneral)
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const { loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance } = useSelector(selectAuthData)
  const { type } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [css, theme] = useStyletron()
  const headingStyle = css({
    margin: '1rem 10px 10px 10px',
    color: 'white',
    ...theme.typography.HeadingMedium,
  })
  const itemProps = {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  }
  const selectedItem = () => {
    const selected = []
    if (!selectedProvider.uuid || providerGeneral.providersList.length <= 0) {
      return selected
    }
    providerGeneral.providersList.map(provider => {
      if (provider.uuid === selectedProvider.uuid) {
        selected.push(provider)
      }
    })

    return selected
  }

  return (
    <>
      <h1 className={headingStyle}>{providerGeneral.title}</h1>
      <FlexGrid flexGridColumnCount={3} flexGridColumnGap='scale800' flexGridRowGap='scale800' marginBottom='scale800'>
        <FlexGridItem {...itemProps}>
          <SDSelect
            type={TYPE.search}
            options={providerGeneral.providersList}
            value={selectedItem()}
            onChange={params => {
              const providerId = params.value[0]?.uuid ?? ''
              if (providerId !== '') {
                dispatch({ type: organizationsManagementActions.LOAD_PROVIDER, providerId })
                navigate('/' + type + '/organisations/provider/' + providerId)
              } else {
                navigate('/' + type + '/organisations/provider')
              }
            }}
          />
        </FlexGridItem>
        <FlexGridItem {...itemProps}>
          {selectedProvider.uuid && (
            <>
              <SDButton
                onClick={() =>
                  navigate('/' + type + '/organisations/provider/edit/' + selectedProvider.uuid)
                }
                size={SIZE.mini}
                kind={KIND.secondary}
                className={css({
                  marginRight: '10px',
                })}
              >
                {t('common:edit')}
              </SDButton>
              <SDButton
                onClick={() =>
                  navigate(
                    '/' + type + '/organisations/provider/' + selectedProvider.uuid + '/offers/add',
                  )
                }
                size={SIZE.mini}
                kind={KIND.secondary}
                className={css({
                  marginRight: '10px',
                })}
              >
                {t('organizationManagement:add_offer_btn')}
              </SDButton>
              {['file_upload', 'ftps', 'api'].includes(selectedProvider.netting_process_type) && (
                <SDButton
                  onClick={() =>
                    navigate(
                      '/' + type + '/organisations/provider/' + selectedProvider.uuid + '/netting',
                    )
                  }
                  size={SIZE.mini}
                  kind={KIND.secondary}
                  className={css({
                    marginRight: '10px',
                  })}
                >
                  {t('organizationManagement:netting_process_btn')}
                </SDButton>
              )}
            </>
          )}
          <SDButton
            onClick={() => navigate('/' + type + '/organisations/provider/add')}
            size={SIZE.mini}
            kind={KIND.tertiary}
          >
            {t('organizationManagement:add_provider_btn')}
          </SDButton>
        </FlexGridItem>
      </FlexGrid>
    </>
  )
}

export default Heading
